export default __webpack_public_path__ + "static/media/check.656197f6.svg";